AuthModel.$inject = ["$modelFactory", "ApiHttp"];export var authDefaults = {
  email: "",
  password: "" };


export function AuthModel($modelFactory, ApiHttp) {
  "ngInject";

  return $modelFactory(ApiHttp.authCheck, {
    defaults: authDefaults });


}